import React from "react";
import "./LoaderStyle.scss";

const Loader = () => {
  return <div className="loader">Loading...</div>;
};

export default Loader;
